<template>
	<portal to="root">
		<div v-if="visible" v-show="isActive" class="popup overlay" :class="{ ...rootClass, animate }"
			:data-cy="currentComponentId"
			@click="onNodeClick"
		>
			<div class="popupBody" @click="onContentNodeClick" :class="classList" :style="popupBodyStyle"
				:data-cy="`${currentComponentId}__popupBody`" ref="popupContent"
			>
				<i v-if="showClose" class="popupClose icon-cancel" @click="close" :data-cy="`${currentComponentId}__close`"></i>
				<div class="popupContent" :style="popupContentStyle">
					<h2 v-if="title">
						<span v-if="isTitleHtml" v-html="title"></span>
						<template v-else>{{ title }}</template>
						<slot name="titleAfter" :parentComponentId="`${currentComponentId}__slotTitleAfter`"></slot>
					</h2>
					<slot :parentComponentId="`${currentComponentId}__slotDefault`"></slot>
				</div>
			</div>
		</div>
	</portal>
</template>

<script>
import ComponentIdentifier from '../mixins/ComponentIdentifier';
import Dialog from '../mixins/Dialog';

export default {
	mixins: [ComponentIdentifier, Dialog],
	props: {
		name: {
			type: String,
			required: true,
		},
		modal: {
			type: Boolean,
			required: false,
			default: false,
		},
		title: String,
		isTitleHtml: Boolean,
		classList: {
			type: Array,
		},
		popupBodyStyle: String,
		popupContentStyle: String,
		closeOnEscape: {
			type: Boolean,
			default: true,
		},
		warningOnEscape: {
			type: Boolean,
			default: false,
		},
		showClose: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			visible: false,
			animate: false,
			active: false,
			node: null,
			contentNode: null,
		};
	},
	created() {
		this.$root.$listen('dialog-open', this.onOpen, this);
		this.$root.$listen('dialog-close', this.onClose, this);

		document.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onKeyDown);
	},
	methods: {
		onKeyDown(event) {
			if (!this.closeOnEscape) {
				return;
			}

			if (event.key === 'Escape' && this.visible) {
				if (!this.modal && !this.warningOnEscape) {
					this.close();
				} else if (this.warningOnEscape) {
					this.$notify.warn(this.$t('warningOnEscapeDialog'));
				}
			}
		},
		onNodeClick() {
			if (!this.ignoreClick && !this.modal && !this.warningOnEscape) {
				this.close();
			} else if (!this.ignoreClick && this.warningOnEscape) {
				this.$notify.warn(this.$t('warningOnEscapeDialog'));
			}
			this.ignoreClick = false;
		},
		onContentNodeClick() {
			this.ignoreClick = true;
		},
		onOpen(arg) {
			this.ignoreClick = false;
			if (arg.name === this.name) {
				this.open();
			}
		},
		onClose(name) {
			if (name === this.name) {
				this.close();
			}
		},
		open() {
			if (this.visible) return;
			// console.debug('open dialog:', this.name);
			this.animate = false;
			this.visible = true;
			this.$emit('open', this.name);
			setTimeout(() => {
				this.animate = true;
			}, 0);
		},
		close(event, quiet) {
			if (!this.visible) {
				return;
			}
			// console.debug('close dialog:', this.name);
			const closeTimeout = (quiet) ? 0 : 200;
			this.animate = false;
			this.$emit('close', this.name);
			setTimeout(() => {
				this.visible = false;
			}, closeTimeout);
		},
	},
};
</script>
